import type { ISelectedSortParams } from '@app/pages/cmms/components/cmms-sort-filters-grouping/interfaces-and-types/sort-item.interfaces';

export function filterEntityByKey<T>(
	arrayToFilter: T[],
	compareKey: string,
	compareValue: string
): T[] {
	if (!arrayToFilter?.length) {
		return [];
	}

	return arrayToFilter.filter(item => item[compareKey] !== compareValue);
}

export function getSortKeyWithOrder(sortParams: ISelectedSortParams): string {
	if (!sortParams.sortColumn) {
		return null;
	}
	// Due to django sort filter to make sort descending order you
	// need to attach '-' before columnName
	const order = sortParams.order === 'desc' ? '-' : '';

	return `${order}${sortParams.sortColumn.columnKey}`;
}

export function getPrivateKeys(items: [{ pk: string }]): string[] {
	return items ? items.map(item => item.pk) : [];
}
